import { Component, OnInit, Inject, ViewChild, Input, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormGroupDirective, FormArray, NgForm, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatSnackBar, MatInput, throwMatDuplicatedDrawerError } from '@angular/material';
import { ErrorStateMatcher } from '@angular/material/core';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component';
import { frequencyDays } from '../../_models/staticArray'
import { ActivatedRoute, Router } from '@angular/router'
import differenceBy from 'lodash/differenceBy';
import { ClientService } from '../../services/client.service';
import { CourseService } from '../../services/course.service';
import { StaffService } from '../../services/staff/staff.service';
import { JobService } from '../../services/jobs/job.service';
import { JobDatesComponent } from '../job-dates/job-dates.component'
import { TimeSheetService } from '../../services/time-sheet.service';
import { MapsService } from '../../services/maps.service';
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-edit-job-modal',
  templateUrl: './edit-job-modal.component.html',
  styleUrls: ['./edit-job-modal.component.scss']
})
export class EditJobModalComponent implements OnInit {

  clients = [];
  courses;
  placeholder = "Starting date"
  instructors;
  jobs;
  addJobForm;
  courseDates = [];
  startingDate;
  temp;
  jobDates: FormArray;
  totalDays = [];
  duration;
  newTitle;
  finalCourseDates = [];
  instructor: FormArray;
  course: FormArray;
  matcher = new MyErrorStateMatcher();
  removeClient
  newClient
  title;
  color;
  client;
  selected;
  instructorData;
  singleJobDate = [];
  loading: Boolean = false;
  selectedClient;
  selectedLocation;
  selectedCourse;
  selectedInstructor = [];
  selectedIQAInstructor = [];
  selectedTrainerInstructor = [];
  dumySelectedInstructor = [];
  deletedInstructor = [];
  jobDateComponent: JobDatesComponent;
  selectedInstructorsForDb = [];
  selectedClientsForDb = []
  newClientsList = [];
  removeClientsList = [];
  deletedInstructorsForDb = [];
  selectedInstructors;
  instlist;
  selectedCourseNew;
  selectedClientNew;
  selectedCourseNameNew;
  selectedClientNameNew;
  minDate: any;
  IQAinstructors;
  jobId;
  sampleSize = []
  finalSampleSize = []
  isValidation = true
  deleteDisabled: Boolean = true;
  DialogData;
  isSubmit
  frequencyDays = frequencyDays
  rgba: any;
  always: any;
  error: any;
  isInstChanged: boolean = false;
  completionPercent: any;
  job: any;
  datesOnCourseChange: any = false;
  tempDateArray = []
  typeOfView: any;
  displayArchive
  displayButton = true
  user
  createdDate
  @ViewChild(JobDatesComponent, { static: true }) jobDatesComp: JobDatesComponent;
  @ViewChild('startDate', { static: true, read: MatInput }) startDate: MatInput;
  totalExam: any;
  resetJob
  dataModel
  @Input('singleJob') singleJob: any;
  @Output() editJobDone: EventEmitter<any> = new EventEmitter<any>();
  previousValue: any;
  isNotApplicable: boolean = false
  endingDate: Date;
  selectedCourseCopy: any;
  date: any;
  map: google.maps.Map;
  endDate: any;
  isDateEdit: boolean = false
  trainersList = [];
  iqaList = [];
  isClient: boolean = false;
  systemDate
  quizStartDate: any;
  quizEndDate: any;

  // for google location
  latitude: number;
  longitude: number;
  isMapJob: boolean = false;
  isQuizRelease: boolean = false;
  // address: string;
  // isMapEdit: boolean = false;
  constructor(public _timeSheetService: TimeSheetService, public _snackBar: MatSnackBar, private router: Router,
    private activatedRoute: ActivatedRoute, public dialog: MatDialog, public _clientService: ClientService, public _courseService: CourseService,
    public _staffService: StaffService, public _jobService: JobService,
    public formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    public _mapsService: MapsService,
    @Inject(MAT_DIALOG_DATA) public data1: any) {
    this.activatedRoute.queryParams.subscribe(() => {
      if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras && this.router.getCurrentNavigation().extras.state) {
        this.job = this.router.getCurrentNavigation().extras.state.job
        this.typeOfView = this.router.getCurrentNavigation().extras.state.view
      }
      // if (this.router.getCurrentNavigation().extras.state.view) {
      //   this.typeOfView = this.router.getCurrentNavigation().extras.state.view
      // }
    })
    this.activatedRoute.params.subscribe(params => {
      this.jobId = params.id;
    })
    // this._timeSheetService.newDateObservable().subscribe((date) => {
    //   console.log("edit-job date", date);
    //   this.systemDate = date
    // })
  }

  ngOnInit() {


    // this.isMapEdit= true
    console.log("when it is open as a modal", this.data1);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("login user role", this.user);

    let size = Object.keys(this.data1).length;

    if (size != 0) {
      this.job = this.data1
      this.createForm()
      let singleJob = this.job
      if (singleJob && !singleJob.sampleSize) {
        singleJob.instructors.forEach((item) => {
          console.log("item in ng on init", item);
          let temp = item.userId.userRole.includes('IQA')
          console.log("this is check the user role", temp);
          if (temp == false) {
            let obj = {
              _id: item._id,
              name: item.name,
              sampleSize: ''
            }
            this.sampleSize.push(obj)
          }
        })
      } else {
        this.sampleSize = singleJob.sampleSize
        //singleJob.sampleSize.forEach((item) => {
        //    let obj = {
        //        _id: item._id,
        //        name: item.name,
        //        sampleSize: ''
        //    }
        //    this.sampleSize.push(obj)
        //})
      }
      this.getClients();
      this.getCourses();
      this.getInstructors();
      this.displayArchive = this.job.isArchive
      this.displayButton = false
      console.warn("@ line 169")
      if (this.job && this.job.createdAt != null) {
        this.createdDate = this.job.createdAt
      }
    } else {
      console.warn("@ line 175")
      this.job = this.singleJob
      let singleJob = this.job
      let objLength = Object.keys(singleJob)
      console.log("this.singleJob", this.singleJob, singleJob, objLength)
      if (objLength && objLength.length) {
        if (singleJob && singleJob.sampleSize && !singleJob.sampleSize.length || singleJob.sampleSize == null) {
          singleJob.instructors.forEach((item) => {
            console.log("item in else part", item);
            let temp = item && item.userId && item.userId.userRole ? item.userId.userRole.includes('IQA') : true
            console.log("this is check the user role", temp);
            if (temp == false) {
              let obj = {
                _id: item._id,
                name: item.name,
                sampleSize: ''
              }
              this.sampleSize.push(obj)
            }
          })
        } else {
          this.sampleSize = singleJob.sampleSize
        }
        this.loading = true;
        if (this.job != null) {
          console.log("IN IF", this.job);
          console.log('Job from edit available', this.job)
          this.displayArchive = this.job.isArchive
          console.warn("@ line 195")
          //let singleJob = this.job
          //if (singleJob && !singleJob.sampleSize) {
          //    singleJob.instructors.forEach((item) => {
          //        let obj = {
          //            _id: item._id,
          //            name: item.name,
          //            sampleSize: ''
          //        }
          //        this.sampleSize.push(obj)
          //    })
          //} 
          //else {
          //    this.sampleSize = singleJob.sampleSize
          //    //singleJob.sampleSize.forEach((item) => {
          //    //    let obj = {
          //    //        _id: item._id,
          //    //        name: item.name,
          //    //        sampleSize: ''
          //    //    }
          //    //    this.sampleSize.push(obj)
          //    //})
          //}
          if (this.job && this.job.createdAt != null) {
            this.createdDate = this.job.createdAt
          }
          this.createForm()
          this.getClients();
          this.getCourses();
          this.getInstructors();
          this.disableDeleteBtn()
        }
        else if (this.singleJob) {
          console.log("IN ELSE IF", this.job);

          console.warn("@ line 208")
          //let singleJob = this.job
          //if (singleJob && !singleJob.sampleSize) {
          //    singleJob.instructors.forEach((item) => {
          //        let obj = {
          //            _id: item._id,
          //            name: item.name,
          //            sampleSize: ''
          //        }
          //        this.sampleSize.push(obj)
          //    })
          //} 
          this.createForm()
        }
        else {
          console.log("IN ELSE", this.jobId)
          this.getJob(this.jobId).then((res) => {
            console.log("response of job", res);
            console.warn("@ line 215")
            this.job = res

            if (this.job && this.job.createdAt != null) {
              this.createdDate = this.job.createdAt
            }


            this.getClients();
            this.getCourses();
            this.getInstructors();
            this.disableDeleteBtn();
          })
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("--------changesIn Edit JOb", changes)
    // this.job = changes.singleJob.currentValue
    // this.createForm()

    if (changes.singleJob && changes.singleJob.currentValue) {
      let objLength = Object.keys(changes.singleJob.currentValue).length
      console.log("Changes in job", changes.singleJob, objLength);
      if (objLength != 0) {
        this.job = changes.singleJob.currentValue
        this.createForm()
        this.getCourses()
        this.getInstructors()
        this.getClients()
      }
      // this.isMapEdit = true;
    }
  }


  createForm() {
    // this.totalDays = []
    console.group(" ****** createForm ****** ")

    this.singleJobDate = this.job.singleJobDate;

    this.date = this.job.startingDate;
    console.log(" createForm job details ", this.job)
    this.tempDateArray = []
    // _.forEach(this.job.singleJobDate, (oneDate) => {
    //   this.tempDateArray.push(new Date(oneDate).toUTCString())
    // })
    _.forEach(this.job.singleJobDate, (oneDate) => {
      this.tempDateArray.push(oneDate)
    })
    // console.log("this.tempDateArray", this.tempDateArray);
    this.totalDays = this.job.totalDays;
    console.log("total days to be send", this.totalDays);

    this.color = this.job.color;
    this.startingDate = new Date(this.job.startingDate)
    this.endingDate = new Date(this.job.endingDate)

    // for google location
    // this.latitude = this.job && this.job.location ? this.job.location.coords.lat : ''
    // this.longitude = this.job && this.job.location ? this.job.location.coords.lng : ''
    // this.address = this.job && this.job.location ? this.job.location.address : ''


    this.addJobForm = this.formBuilder.group({
      title: new FormControl(this.job.title, Validators.required),
      // jobColor: new FormControl(this.job.color, Validators.required),
      // client: new FormControl('', Validators.required),
      instructors: new FormControl(''),
      IQAinstructors: new FormControl(''),
      // location: new FormControl('', Validators.required),
      course: new FormControl('', Validators.required),
      clients: this.formBuilder.array(this.getClientFormArray(this.job.clients)),
      startingDate: new FormControl(new Date(this.job.startingDate)),
      // endingDate: new FormControl((this.endingDate)),
      singleJobDate: new FormControl(this.tempDateArray, Validators.required),
      totalDays: new FormControl(this.totalDays, Validators.required),
      isArchive: new FormControl(''),
      scheduleDates: new FormControl(this.job.scheduleDates, Validators.required),
      trackHours: new FormControl((this.job.course && this.job.course.trackHours) ? this.job.course.trackHours : false),
      hasExam: new FormControl((this.job.course && this.job.course.hasExam) ? this.job.course.hasExam : false),
      hasIlpForm: new FormControl((this.job.course && this.job.course.hasIlpForm) ? this.job.course.hasIlpForm : false),
      startTime: new FormControl(this.job.startTime ? this.job.startTime : ''),
      roomNumber: new FormControl(this.job.roomNumber ? this.job.roomNumber : ''),
      location: new FormControl(this.job.location && this.job.location.address ? this.job.location.address : '')
      // for google location
      // location: new FormControl(this.job.location && this.job.location ? this.job.location : ''),

      //sampleSize: this.formBuilder.array(this.getSampleSizeArray(this.selectedInstructor)),
    });
    console.log("Form created", this.addJobForm)
    if (this.job && this.job.endingDate) {
      // this.endingDate = this.job.endingDate
      this.endingDate = new Date(this.job.endingDate)
    }
    console.log("this.job ----->>>>>", this.job, this.job && this.job.scheduleDates && this.job.scheduleDates == true)
    if (this.job && this.job.scheduleDates && this.job.scheduleDates == true) {
      this.isNotApplicable = true
      this.endingDate = new Date(this.job.endingDate)
      this.addJobForm.removeControl('singleJobDate')
      this.addJobForm.removeControl('totalDays')
      this.addJobForm.addControl('endingDate', new FormControl(this.endingDate, Validators.required));
    } else {
      this.isNotApplicable = false
    }


    if (this.user && this.user.isClient) {
      this.isClient = true
      this.addJobForm.controls['title'].disable();
      // this.addJobForm.controls['jobColor'].disable();
      this.addJobForm.controls['clients'].disable();
      this.addJobForm.controls['instructors'].disable();
      this.addJobForm.controls['IQAinstructors'].disable();
      this.addJobForm.controls['course'].disable();
      this.addJobForm.controls['startingDate'].disable();
      if (this.job && this.job.scheduleDates && !this.job.scheduleDates) {
        this.addJobForm.controls['singleJobDate'].disable();
        this.addJobForm.controls['totalDays'].disable();
      }
      this.addJobForm.controls['trackHours'].disable();
      this.addJobForm.controls['hasExam'].disable();
      this.addJobForm.controls['isArchive'].disable();
      this.addJobForm.controls['scheduleDates'].disable();
    }
    this.viewLocation(this.job)
    // this.formControlValueChanged()
    // console.groupEnd()
  }


  viewLocation(job) {
    let location = job.clients[0].location
    if (location && location.address && location.address.length) {
      this.latitude = location.locationGeometry.coordinates[1]
      this.longitude = location.locationGeometry.coordinates[0]
    } else {
      console.log("Here the job details for location", job, location);
      this._mapsService.getLocation(location.title).subscribe((locationData) => {
        console.log("This is the location details using address", locationData.lat(), locationData.lng());
        if (locationData == null) return locationData
        this.latitude = locationData.lat()
        this.longitude = locationData.lng()
      })
    }

  }


  formControlValueChanged() {
    this.addJobForm.get('course').valueChanges.subscribe(
      (mode: string) => {
        console.log("when change course value", mode);
      });
  }

  getSampleSizeArray(sampleSize): Array<any> {
    console.warn("sampleSize passed", sampleSize)
    const sampleSizeArr = [];
    if (sampleSize && sampleSize.length) {
      _.forEach(sampleSize, async (sample) => {
        console.warn("samplesamplesamplesamplesample", sample)
        await sampleSizeArr.push(new FormGroup({
          id: new FormControl((sample && sample._id) ? sample._id : ''),
          name: new FormControl((sample && sample.name) ? sample.name : ''),
          size: new FormControl(''),
        }))
      })
      return sampleSizeArr;
    } else {
      return [this.formBuilder.group({
        id: new FormControl(''),
        name: new FormControl(''),
        size: new FormControl(''),
      })]
    }
    this.cdr.detectChanges()
  }

  get sampleSizeGroup() { return <FormArray>this.addJobForm.get('sampleSize') }

  getClientFormArray(clients): Array<any> {
    const clientsArr = [];
    if (clients && clients.length) {
      _.forEach(clients, async (client) => {
        if (client.client) {
          await clientsArr.push(new FormGroup({
            client: new FormControl(client.client._id),
            location: new FormControl(client.location._id),
          }))
        }

      })
      return clientsArr;
    } else {

    }
  }



  getClientsLocation(clientId, location) {
    // console.log("what is the value of location", clientId, location);

    // console.log('getTing clocations', this.clients[_.findIndex(this.clients, {_id: clientId})])
    let client = this.clients[_.findIndex(this.clients, { _id: clientId })].locations;
    // console.log("single client data", client);

    if (location) {

      const index1 = _.findIndex(client, function (o) { return o._id == location })
      if (index1 > -1) {

        client[index1]['added'] = true
      }

    }
    return client

  }

  ngAfterViewChecked() {
    // this.message = 'all done loading :)'
    this.cdr.detectChanges();
  }


  addClientInClients(event, client) {

    console.log("what is the event value", event.value);
    let clientId = client
    const index = _.findIndex(this.clients, function (o) { return o._id == clientId })
    if (index > -1) {
      const index1 = _.findIndex(this.clients[index].locations, function (o) { return o._id == event.value })
      console.log("whatt is the index 1 value", index1);
      this.clients[index].locations[index1]['added'] = true
      console.log("remaining client value", this.clients[index]);
      // this.previousValue = event.value
    }

    this.newClientsList = this.addJobForm.controls['clients'].value

    console.log("what is the client value", this.addJobForm.controls['clients'].value);

    let exits = this.addJobForm.controls['clients'].value
    exits.forEach((singleValue) => {
      this.clients[index].locations.forEach((location) => {
        if (location._id == singleValue.location) {
          console.log("nothing to do");

        } else {
          if (location && location.added)
            delete location['added']
        }
      })
    })
  }


  AddMultipleClients() {
    const control = <FormArray>this.addJobForm.controls.clients

    control.push(this.formBuilder.group({

      client: new FormControl('', Validators.required),
      location: new FormControl('', Validators.required),
    }))

    // this.newClientsList.push(control.value.value)

    console.log("this add multiple client data =======>", this.newClientsList)
  }

  deleteClient(data, i) {
    console.log("what is in client", data);
    console.log("index value============", i);
    const control = <FormArray>this.addJobForm.controls.clients
    control.removeAt(i)
    let clientId = data.value.client
    let locationId = data.value.location

    console.log('remove client data herre ==================>', data.value)
    this.removeClientsList.push(data.value)
    const index = _.findIndex(this.clients, function (o) { return o._id == clientId })


    console.log("main index value", index);

    if (index > -1) {
      const index1 = _.findIndex(this.clients[index].locations, function (o) { return o._id == locationId })
      console.log("location index value===========", index1);
      // console.log("whatt is the index 1 value", index1);
      if (index1 > -1) {
        delete this.clients[index].locations[index1]['added']
      }
    }
  }




  get multipleClientsGroup() { return <FormArray>this.addJobForm.get('clients') }

  multipleClients(clients) {
    console.log("tempForm  ", clients);
    let clientArray = []
    if (clients && clients.length) {
      for (let i = 0; i < clients.length; i++) {
        console.log("single client data==========", clients[1]);
        clientArray.push(this.formBuilder.group({
          clientId: new FormControl(clients[i]._id),
          client: new FormControl(clients[i].client),
          location: new FormControl(clients[i].location._id),
        }))
      }
      console.log("%cedit client value", "color:red", clientArray);
      return clientArray
    }
    else {
      return this.formBuilder.group({
        client: new FormControl(''),
        location: new FormControl(''),
      })
    }
  }




  courseChanged(event) {
    console.log('EVENT', event.value)
    this.datesOnCourseChange = false
    this.selectedCourse = event.value;
    this.duration = event.value.duration
    this.selectedCourseNew = event.value._id;
    this.selectedCourseNameNew = event.value.title;
    this.datesOnCourseChange = true
    this.totalExam = event.value.exams
    this.isQuizRelease = this.selectedCourse.isQuizRelease;
    this.addJobForm.patchValue({ hasExam: event.value.hasExam })
    this.addJobForm.patchValue({ hasIlpForm: event.value.hasIlpForm })
    this.addJobForm.patchValue({ trackHours: event.value.trackHours })
    if (this.isQuizRelease) {
      this.addJobForm.addControl('quizStartTime', new FormControl(''));
      this.addJobForm.addControl('quizEndTime', new FormControl(''));
      this.addJobForm.addControl('quizStartDate', new FormControl(''));
      this.addJobForm.addControl('quizEndDate', new FormControl(''));
    }
    else {
      this.addJobForm.removeControl('quizStartTime');
      this.addJobForm.removeControl('quizEndTime');
      this.addJobForm.removeControl('quizStartDate');
      this.addJobForm.removeControl('quizEndDate');
    }
  }

  clientChanged() {
  }

  locationChanged(data) {
    console.log("Location", data.value)
    this.addJobForm.controls['location'].setValue(data.value._id)
  }
  datesForJobChange(index) {
    this.finalCourseDates[index] = this.addJobForm.controls.singleJobDate.value
  }

  // searchDays($event) { // starting date change
  //   this.startingDate = $event.value;
  //   this.temp = moment($event.value);
  // }

  daySelection(obj) {// event from app-job-dates
    console.log("-----DAY SELECTION EVENT-----", this.singleJobDate)
    console.log("OBJ", obj)
    let temp = JSON.parse(JSON.stringify(this.singleJobDate))
    ///////////////////////////////////////////////////////
    let dateArray = obj.singleJobDates
    let arrayLength = obj.singleJobDates.length;
    for (let i = 0; i < arrayLength; i++) {
      let date = new Date(dateArray[i].date)
      let finalDate = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
      temp[i].date = finalDate
    }

    this.singleJobDate = temp
    console.log("this is after change date array", this.singleJobDate);

    if (obj && obj.isEdit) {
      this.isDateEdit = obj.isEdit
    }

    ///////////////////////////////////////////////////////////
    this.totalDays = obj.totalDays;
    this.addJobForm.patchValue({
      singleJobDate: this.singleJobDate
    })
    this.addJobForm.get('singleJobDate').updateValueAndValidity()
    this.addJobForm.patchValue({
      totalDays: obj.totalDays
    })
    this.addJobForm.get('totalDays').updateValueAndValidity()
    console.log("this is the final array of value", this.isDateEdit);

  }

  async instructorChanged(data) {
    this.isInstChanged = true;

    this.selectedTrainerInstructor = data.value;
    // this.selectedInstructor = 
    this.selectedIQAInstructor = this.selectedIQAInstructor.filter(function (element) {
      return element !== undefined;
    });

    this.dumySelectedInstructor = this.selectedInstructor = this.selectedIQAInstructor.concat(this.selectedTrainerInstructor);


    console.log('selected Trainer instructor', this.selectedInstructor)
    // console.log('selected iqa instructor',this.selectedIQAInstructor)
    console.log('sampleSize', this.sampleSize)
    // this.sampleSize = []
    await this.selectedInstructor.forEach((inst) => {
      let obj = {
        _id: inst._id,
        name: inst.name,
        sampleSize: ''
      }
      if (this.sampleSize.length) {
        let index = _.findIndex(this.sampleSize, function (o) { return o._id == inst._id })
        if (index > -1) {
          //this.sampleSize[index].sampleSize = this.sampleSize[index].sampleSize
        } else {
          let temp = inst.userId.userRole.includes('IQA')
          console.log("this is check the user role", temp);
          if (temp == false) {
            this.sampleSize.push(obj)
          }
        }
      } else {
        let temp = inst.userId.userRole.includes('IQA')
        console.log("this is check the user role", temp);
        if (temp == false) {
          this.sampleSize.push(obj)
        }
      }
    })
    // this.sampleSize = _.intersectionBy(this.sampleSize, this.selectedTrainerInstructor, '_id');
    this.sampleSize = _.intersectionBy(this.sampleSize, this.selectedInstructor, '_id');
    this.getSampleSizeArray(this.selectedInstructor)
    this.cdr.detectChanges()
  }




  async instructorChangedIQA(data) {
    console.log("this.selected instructor ============>", data);

    // this.isInstChanged = true;
    this.selectedIQAInstructor = data.value;



    this.selectedTrainerInstructor = this.selectedTrainerInstructor.filter(function (element) {
      return element !== undefined;
    });    // // console.log("finally get result", this.selectedInstructor);
    this.dumySelectedInstructor = this.selectedInstructor = this.selectedIQAInstructor.concat(this.selectedTrainerInstructor);

  }

  checkApplicable(event) {
    console.log("event of applicable", event);
    console.log("value of cvheckbox", this.isNotApplicable);

    if (this.isNotApplicable) {
      console.log("this is for end date add");
      // this.addJobForm.addControl('endingDate', '');

      this.addJobForm.addControl('endingDate', new FormControl((this.endingDate) ? this.endingDate : '', Validators.required));


    } else {
      console.log("this is end date not add");
      this.addJobForm.removeControl('endingDate');
      // this.addJobForm.addControl('singleJobDate', new FormControl(''))
    }

  }

  disableDeleteBtn() {
    console.log("call this function or not==========", this.job);

    if (this.job.completion == 0 || this.job.completion == 100 || this.job.numberOfLearners == 0) {
      this.deleteDisabled = false;
    } else {
      this.deleteDisabled = true;
    }
  }

  sampleSizeChange(event, index) {
    console.log("event", event.target.value)

    this.sampleSize[index].sampleSize = event.target.value

  }
  addJob() {
    if (this.addJobForm.valid) {

      console.log("this.addJobForm.value", this.addJobForm.value);
      if (this.addJobForm.controls['title'].value) {
        this.newTitle = this.addJobForm.controls['title'].value
      } else {
        this.newTitle = this.selectedClient.name + '-' + this.selectedCourseNameNew;
      }
      // finding instructor
      console.log("in if this.isInstChanged");
      // this.selectedInstructor=this.selectedInstructor.concat(this.selectedIQAInstructor)
      // this.selectedInstructor=this.selectedInstructor.concat(this.selectedTrainerInstructor)

      // if (this.dumySelectedInstructor && !this.dumySelectedInstructor.length) {
      //   this.dumySelectedInstructor = this.job.instructors
      // }



      // this.dumySelectedInstructor.forEach((item) => {
      //   console.log("selctor ID Find :", this.dumySelectedInstructor)
      //   this.selectedInstructorsForDb.push(item._id)
      // })

      /*************************************************************************
       * new client add remove process 
       * *****************************************************************************
       */
      console.log('slected client Find :', this.job.clients)
      let newArrayClient = []
      let addNewClient = []
      this.job.clients.forEach(item => {
        newArrayClient.push({ client: item.client._id, location: item.location._id })
      });

      console.log("******************************************************", newArrayClient)

      /*****************remove duplicate data client array  */

      // addNewClient = _.difference(this.newClientsList, newArrayClient)

      addNewClient = this.newClientsList.filter(function (obj) {
        return !newArrayClient.some(function (obj2) {
          return obj.client == obj2.client;
        });
      });

      console.log('hello check remove client list', this.removeClientsList)
      console.log('add client data +++++++++++++++', addNewClient)

      /************************************************************************************************* */

      // console.log("this.selectedInstructorsForDb ------------- this.selectedInstructorsForDb", this.selectedInstructorsForDb);

      // console.log("dumySelectedInstructor 000000000", this.dumySelectedInstructor);

      this.selectedInstructorsForDb = this.selectedTrainerInstructor.concat(this.selectedIQAInstructor)
      this.job.instructors.forEach((item) => {
        this.deletedInstructorsForDb.push(item)
      })
      console.log("find delete instructor db", this.deletedInstructorsForDb)
      this.deletedInstructor = _.differenceBy(this.deletedInstructorsForDb, this.selectedInstructorsForDb, '_id')

      console.log("selcted instrcuctor db", this.deletedInstructor)


      let unique = [];
      let newAddedIns = [];
      let alreadyExists = [];
      let aleredyExistsClient = [];


      // if (this.job.client._id) {
      // this.newClient = this.selectedClient._id;
      // this.removeClient = this.job.client;
      // }
      // 

      this.selectedInstructorsForDb.map(x => unique.filter(a => a == x).length > 0 ? null : unique.push(x));

      this.job.instructors.forEach((item) => {
        alreadyExists.push(item)
      })



      newAddedIns = _.differenceBy(unique, alreadyExists, '_id');
      let tempStartDate = this.addJobForm.controls['startingDate'].value
      console.log('newClientId=====>>', this.addJobForm);
      let editedJob = {

        title: this.newTitle,
        // jobColor: this.addJobForm.controls['jobColor'].value,
        // client: this.selectedClient._id,
        // location: this.addJobForm.controls['location'].value._id,
        instructor: unique,
        newInstructor: newAddedIns,
        newClient: addNewClient,
        clients: this.addJobForm.controls['clients'].value,
        course: this.addJobForm.controls['course'].value._id,
        startingDate: ((tempStartDate.getMonth() > 8) ? (tempStartDate.getMonth() + 1) : ('0' + (tempStartDate.getMonth() + 1))) + '/' + ((tempStartDate.getDate() > 9) ? tempStartDate.getDate() : ('0' + tempStartDate.getDate())) + '/' + tempStartDate.getFullYear(),
        totalDays: this.totalDays,
        singleJobDate: this.singleJobDate,
        removedInstructor: this.deletedInstructor,
        removedClient: this.removeClientsList,
        isArchive: this.addJobForm.controls['isArchive'].value,
        scheduleDates: this.addJobForm.controls['scheduleDates'].value,
        sampleSize: this.sampleSize,
        hasExam: this.addJobForm.controls['hasExam'].value,
        hasIlpForm: this.addJobForm.controls['hasIlpForm'].value,
        trackHours: this.addJobForm.controls['trackHours'].value,
        isEdit: this.isDateEdit,
        startTime: this.addJobForm.controls['startTime'].value,
        roomNumber: this.addJobForm.controls['roomNumber'].value,
        location: {
          // for google location
          // coords: { lat: this.latitude, lng: this.longitude },
          address: this.addJobForm.controls['location'].value
        },
      }

      if (this.selectedCourse.isQuizRelease) {
        editedJob['quizStartTime'] = this.addJobForm.controls['quizStartTime'].value
        editedJob['quizEndTime'] = this.addJobForm.controls['quizEndTime'].value
        editedJob['quizStartDate'] = this.addJobForm.controls['quizStartDate'].value
        editedJob['quizEndDate'] = this.addJobForm.controls['quizEndDate'].value
      }

      if (this.endingDate && this.isNotApplicable) {
        let tempEndDate = this.addJobForm.controls['endingDate'].value
        editedJob['endingDate'] = ((tempEndDate.getMonth() > 8) ? (tempEndDate.getMonth() + 1) : ('0' + (tempEndDate.getMonth() + 1))) + '/' + ((tempEndDate.getDate() > 9) ? tempEndDate.getDate() : ('0' + tempStartDate.getDate())) + '/' + tempEndDate.getFullYear()
        console.log("what is the value of ending date value", this.endingDate);
      }

      this.error = ''

      if (this.selectedCourseCopy._id != editedJob.course) {
        console.log("this is not for same course");
        editedJob['isCourse'] = true
      } else {
        console.log("this is for same course", this.job.course._id);
        editedJob['course'] = this.job.course._id
        editedJob['isCourse'] = false
      }

      // editedJob['clients'] = this.job.client

      console.log("what is edit job value", editedJob, this.selectedCourseCopy);
      console.warn("this.sampleSize", this.sampleSize)

      this._jobService.editJobs(editedJob, this.job._id)
        .subscribe(data => {
          console.log("after update job data", data);

          this.handleSnackBar({ msg: "Job edited successfully!", button: "Ok" });
          let param = {
            courseType: this.addJobForm.controls['course'].value.type
          }
          console.log("param =====================", param)
          this.editJobDone.emit({ editJob: data })
          this.router.navigate(['/jobs/' + this.job._id], { queryParams: param })
          // this.router.navigateByUrl('/jobs', { state: { view: this.typeOfView } });
        }, err => {
          if (err.msg == '"totalDays" does not contain 1 required value(s)') {
            this.error = "Choose at least one day!"
          } else {
            this.error = err.msg
          }
          this.loading = false;
        });

    }
    else {
      this.addJobForm.markAllAsTouched()
      this.isSubmit = true
      this.error = "All fields are required"
      console.log("Form is Invalid", this.addJobForm)
    }
  }
  setStartTime(value) {
    console.log("value while change time", value);
    this.addJobForm.patchValue({ startTime: value })
  }

  // function google location

  // setCurrentLocation(mapCurrentValue) {
  // console.log("hello common map component Return Value...", mapCurrentValue)
  // this.latitude = mapCurrentValue.latitude
  // this.longitude = mapCurrentValue.longitude
  // this.address = mapCurrentValue.address
  // 
  // }
  delete() {
    console.log('this.JobData:', this.job);
    this.jobId = this.job._id
    this.addJobForm.reset()
    this.resetJob = true
    this.totalDays = []
    this.ngOnInit()

    let id = this.job._id
    this.openDialog(DeleteConfirmModalComponent, "Job").subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this._jobService.deleteJobs(id).subscribe(() => {
          this.loading = false;
          this.handleSnackBar({ msg: "Job Deleted successfully!", button: "Ok" });
          this.router.navigateByUrl('/multi-job-list', { queryParams: { currentTab: 0 } });
        }, () => {
          this.handleSnackBar({ msg: "Something Went Wrong!", button: "Ok" });
          this.loading = false;
        });
      }
    })
  }





  // Utility functions
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '500px' });
    return dialogRef.afterClosed();
  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  dateFilter = (d: Date) => {

    const arrayListDate = this.singleJobDate.map((o) => {
      return new Date(o.date).valueOf()

    })
    return arrayListDate.indexOf(d.valueOf()) == -1;

  };

  dateFilter2 = (d: Date) => {
    let tempArray = []
    tempArray.push(new Date(this.addJobForm.controls['endingDate'].value).valueOf())
    return tempArray.indexOf(d.valueOf()) == -1;
  }

  dateFilter3 = (d: Date) => {
    let tempArray = []
    tempArray.push(new Date(this.addJobForm.controls['startingDate'].value).valueOf())
    return tempArray.indexOf(d.valueOf()) == -1;
  }

  onChangedate(value) {
    console.log("function call date", value)
    this.date = value;
    this.startingDate = new Date(value);
    this.duration = this.selectedCourse.duration;
    this.temp = moment(new Date(value));
    this.addJobForm.patchValue({ startingDate: value })
    console.log("event call sucessfully", this.addJobForm.value)
  }

  onChangeEndDate(value) {
    this.endingDate = new Date(value);
    this.addJobForm.patchValue({ endingDate: this.endingDate })
    console.log("event call sucessfully", value, this.addJobForm.value)
    // this.dateisValid2 = true;
    // this.isSubmit2 = false
  }

  async instructorChange(data) {
    console.log("when user is selected", data);
    this.selectedTrainerInstructor = data.value;
    await this.selectedTrainerInstructor.forEach((inst) => {
      let obj = {
        _id: inst._id,
        name: inst.name,
        sampleSize: ''
      }
      if (this.sampleSize.length) {
        let index = _.findIndex(this.sampleSize, function (o) { return o._id == inst._id })
        if (index > -1) {
          //this.sampleSize[index].sampleSize = this.sampleSize[index].sampleSize
        } else {
          if (inst.role == 'trainer') {
            this.sampleSize.push(obj)
          }
        }
      } else {
        if (inst.role == 'trainer') {
          this.sampleSize.push(obj)
        }
      }
    })
    this.sampleSize = _.intersectionBy(this.sampleSize, this.selectedTrainerInstructor, '_id');
    this.getSampleSizeArray(this.selectedTrainerInstructor)
    this.cdr.detectChanges()
    this.dropDownDisable()
  }
  IQAChange(data) {
    console.log("whene user selected", data);
    this.selectedIQAInstructor = data.value;
    this.dropDownDisable()
  }

  dropDownDisable() {
    const differences1 = differenceBy(this.trainersList, this.selectedIQAInstructor, '_id')
    if (differences1 && differences1.length) {
      this.trainersList.map(item => {
        if (differences1.includes(item))
          item.isSelected = false
        else
          item.isSelected = true
      })
    }
    const differences2 = differenceBy(this.iqaList, this.selectedTrainerInstructor, '_id')
    if (differences2 && differences2.length) {
      this.iqaList.map(item => {
        if (differences2.includes(item))
          item.isSelected = false
        else
          item.isSelected = true
      })
    }
    this.getSampleSizeArray(this.selectedTrainerInstructor)
  }

  // API CALLS
  getClients() {
    console.group(" ******** getClients ******** ", this.job)
    this._clientService
      .getClients()
      .subscribe((clients) => {

        this.clients = JSON.parse(JSON.stringify(clients));
        this.loading = false;

        console.log("what is the value of all job form", this.addJobForm);
        console.log("all ready added client in get clients data", this.job.clients);

        if (this.job.clients && this.job.clients.length) {
          this.job.clients.forEach((singleClient) => {
            const element = this.clients.find((o) => {
              return o._id == singleClient.client._id
            })
            console.log("single element of client", element);
            singleClient.client.locations = element.locations
          })
        }
      });
  }
  onChangeQStart(value) {
    this.quizStartDate = value;
    this.addJobForm.patchValue({ quizStartDate: this.quizStartDate })
    console.log("event call sucessfully", this.addJobForm.value)
  }

  onChangeQEnd(value) {
    this.quizEndDate = value;
    this.addJobForm.patchValue({ quizEndDate: this.quizEndDate })
    console.log("event call sucessfully", this.addJobForm.value)
  }

  getCourses() {
    this._courseService.getCourses().subscribe((courses) => {
      this.courses = courses;
      let temp = this.job;
      console.log("what is the selected job", this.job);

      let index = _.findIndex(this.courses, function (o) {
        // console.log("o.title", o.title, 'temp.course.title', temp.course.title)
        return o._id == temp.course.templateId
      })
      if (index > -1) {
        this.selectedCourse = this.courses[index];
        this.selectedCourseCopy = this.courses[index];
        this.isQuizRelease = this.selectedCourse.isQuizRelease;
        this.duration = this.selectedCourse.duration;
        this.totalExam = this.selectedCourse.exams
        if (this.isQuizRelease) {
          this.quizStartDate = this.job.quizStartDate;
          this.quizEndDate = this.job.quizEndDate;
          this.addJobForm.addControl('quizStartTime', new FormControl(this.job.quizStartTime));
          this.addJobForm.addControl('quizEndTime', new FormControl(this.job.quizEndTime));
          this.addJobForm.addControl('quizStartDate', new FormControl(this.quizStartDate));
          this.addJobForm.addControl('quizEndDate', new FormControl(this.quizEndDate));
          console.log("getCourses() isQuizRelease", this.addJobForm.controls);
        }
      }
      this.addJobForm.controls.course.setValue(this.selectedCourse);
      console.log("this.selectedCourse", this.selectedCourse)
    });
  }

  getInstructors() {
    let getTwoArray = true
    this._staffService.getInstructors(getTwoArray).subscribe((instructors) => {
      console.log("instrutores list", instructors);
      console.log("instructors------------> ", instructors);
      if (instructors && instructors.trainers) {
        this.trainersList = instructors.trainers.map((value) => ({ ...value, role: 'trainer', isSelected: false }));
      }
      if (instructors && instructors.iqa) {
        this.iqaList = instructors.iqa.map((value) => ({ ...value, role: 'IQA', isSelected: false }));
      }
      this.instructors = this.job.instructors;
      let tempInsts = this.job.instructors;
      console.log("what is temp value", tempInsts);
      if (tempInsts && tempInsts.length)
        this.getSelectedStaff(tempInsts)
    });
  }

  getSelectedStaff(staff) {
    let i, j
    let tempInsts = []
    let tempIqas = []
    staff.forEach(element => {
      i = _.findIndex(this.trainersList, function (o) {
        return ((o._id == element._id) && (o.role == element.role)) ? o : ''
      })
      console.log("elemenet------> ", element, "i-------->", i);
      if (i > -1) {
        tempInsts.push(this.trainersList[i])
      }

    });
    this.selectedTrainerInstructor = tempInsts
    tempInsts = []
    staff.forEach(element => {
      j = _.findIndex(this.iqaList, function (o) {
        return ((o._id == element._id) && (o.role == element.role)) ? o : ''
      })
      console.log("elemenet------> ", element, "j-------->", j);
      if (j > -1) {
        tempIqas.push(this.iqaList[j])
      }
    });
    this.selectedIQAInstructor = tempIqas
    tempIqas = []
    // this.selectedTrainerInstructor = _.intersectionBy(this.trainersList, staff, '_id');
    // this.selectedIQAInstructor = _.intersectionBy(this.iqaList, staff, '_id');
    console.log("this.selectedTrainerInstructor----->", this.selectedTrainerInstructor);
    console.log("this.selectedIQAInstructor----->", this.selectedIQAInstructor);
    this.dropDownDisable()
    this.addJobForm.controls.instructors.setValue(this.selectedTrainerInstructor);
    this.addJobForm.controls.IQAinstructors.setValue(this.selectedIQAInstructor);

    this.selectedTrainerInstructor.forEach((inst) => {
      let obj = {
        _id: inst._id,
        name: inst.name,
        sampleSize: ''
      }
      if (this.sampleSize.length) {
        let index = _.findIndex(this.sampleSize, function (o) { return o._id == inst._id })
        if (index > -1) {
          //this.sampleSize[index].sampleSize = this.sampleSize[index].sampleSize
        } else {
          if (inst.role == 'trainer') {
            this.sampleSize.push(obj)
          }
        }
      } else {
        if (inst.role == 'trainer') {
          this.sampleSize.push(obj)
        }
      }
    })
    this.sampleSize = _.intersectionBy(this.sampleSize, this.selectedTrainerInstructor, '_id');
    this.getSampleSizeArray(this.selectedTrainerInstructor)
    this.cdr.detectChanges()
  }

  /**
   * divide abd store instrictore different array
   */
  divideIQAandTrainer() {

    let dataIQA = [];
    let intList = []
    this.instlist = []
    this.IQAinstructors = []
    console.log("get IQA instructor====================>", this.instructors)
    this.instructors.forEach((item) => {
      let temp = item.userId.userRole.includes('IQA')

      console.log("temp value", temp);
      if (temp == true) {
        dataIQA.push(item)
      } else {
        intList.push(item)
      }

      //  return item.userId.userRole="IQA"

    });
    this.instlist = intList
    this.IQAinstructors = dataIQA
    // console.log("check IQA Instrucotr data", this.IQAinstructors = dataIQA);
    console.log("only inst list", this.instlist = intList);
    /************************************************
   * next step IQA SELECT USER //************************** */
    /**********************************************/


    /************************************************
     * next step IQA SELECT USER //************************** */
    /**********************************************/

    let temp = this.job;
    let tempInsts = []
    console.log("what is temp value", temp);



    let index11 = _.findIndex(temp.instructors, function (o) {
      if (o && o._id) {

        let index2 = _.findIndex(intList, function (i) {
          // console.log("i.name", i.name, "o.name", o.name)
          return i._id == o._id
        })
        tempInsts.push(intList[index2])
      }
    })
    this.selectedTrainerInstructor = tempInsts;

    // this.selectedIQAInstructor = tempInsts;
    // this.selectedInstructor=this.selectedInstructor.concat(this.selectedIQAInstructor)
    this.getSampleSizeArray(this.selectedTrainerInstructor)
    console.log("this.selectedIQAInstructor", this.selectedTrainerInstructor)
    this.addJobForm.controls.instructors.setValue(this.selectedTrainerInstructor);

    /************************************************
        * next step Trainer SELECT USER //************************** */
    /**********************************************/

    let tempjob = this.job;
    let tempIQAInsts = []
    console.log("what is temp value", tempjob);

    let index = _.findIndex(tempjob.instructors, function (o) {
      if (o && o._id) {

        let index2 = _.findIndex(dataIQA, function (i) {
          // console.log("i.name", i.name, "o.name", o.name)
          return i._id == o._id
        })
        tempIQAInsts.push(dataIQA[index2])
      }
    })
    this.selectedIQAInstructor = tempIQAInsts;
    console.log("qhat is the iqa user", this.IQAinstructors);

    // this.selectedInstructor=this.selectedInstructor.concat(this.selectedTrainerInstructor)
    this.getSampleSizeArray(this.selectedIQAInstructor)
    console.log("this.selectedTrainerInstructor", this.selectedIQAInstructor)
    this.addJobForm.controls.IQAinstructors.setValue(this.selectedIQAInstructor);


  }


  getJob(jobId) {
    return new Promise((resolve) => {


      this.loading = true;
      this._jobService.getJobById(jobId).subscribe((jobs) => {
        console.log(' job111 ', jobs.data[0]);
        console.group(" ******* getJob ******** ", jobs)
        let singleJob = jobs.data[0]
        if (singleJob && !singleJob.sampleSize) {
          singleJob.instructors.forEach((item) => {
            console.log("single inst data", item);
            let temp = item.userId.userRole.includes('IQA')
            console.log("this is check the user role", temp);
            if (temp == false) {
              let obj = {
                id: item._id,
                name: item.name,
                sampleSize: ''
              }
              this.sampleSize.push(obj)
            }
          })
        }
        this.displayArchive = jobs.data[0].isArchive
        this.loading = false;
        this.completionOfJob(jobs.data[0])
        console.log("this.sampleSize in get jobs", this.sampleSize)
        resolve(jobs.data[0])
        console.groupEnd()
      });
    })
  }



  deleteJob() {
    console.log("single job value", this.job);
    console.log("only- id", this.job._id);
    let obj = {
      jobId: this.job._id,
      isDelete: false
    }
    this.openDialog(DeleteConfirmModalComponent, "Job").subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this._jobService.deleteJobs(JSON.stringify(obj)).subscribe(() => {
          this.loading = false;
          this.handleSnackBar({ msg: "Job Deleted successfully!", button: "Ok" });
          this.router.navigateByUrl('/multi-job-list', { state: { view: this.typeOfView } });
        }, () => {
          this.handleSnackBar({ msg: "Something Went Wrong!", button: "Ok" });
          this.loading = false;
        });
      }

      console.log("confirm data", confirm)
    })

  }


  // REMOVE THIS FUNCTION AFTER SERVER SIDE CHANGES
  completionOfJob(job) {
    return new Promise(() => {
      this._timeSheetService.getSystemDate().subscribe((date) => {
        // let date = this.systemDate
        console.log("what is time sheer date", date);

        let start = new Date(job.singleJobDate[0]).getTime()
        let end = new Date(job.singleJobDate[job.singleJobDate.length - 1]).getTime()
        let today = date.sytemTime
        let totalDays = (end - start) / (1000 * 3600 * 24)
        let daysPassed = (today - start) / (1000 * 3600 * 24)
        this.completionPercent = Math.round((daysPassed / totalDays) * 100);
        if (this.completionPercent > 100) {
          console.log(job.title, "complete==", this.completionPercent);
          this.completionPercent = 100;
        }
        else if (this.completionPercent < 0) {
          console.log(job.title, "has NOT begun==", this.completionPercent);
          this.completionPercent = 0;
        }
        // else { console.log(job.title, "in progress==", this.completionPercent); }
        job["completion"] = this.completionPercent;
        console.log("IN COMPLITION FUNCTION", job);
      })
    });
  }


  archiveJob(event) {
    console.log("when check box is selected", event);

  }


  removeClientFormClients(index) {
    console.log(" check here index for remove from selection ", index)



    let clientCopy = this.job.client[index].client;
    let locationCopy = this.job.client[index].location;
    this.job.client.splice(index, 1)

    const foundClientIndex = _.findIndex(this.clients, function (o) { return o._id == clientCopy._id })

    if (foundClientIndex > -1) {
      // console.log(" Client Found ::: ", this.clients[foundClientIndex] ) 
      this.clients[foundClientIndex]['locations'].push(locationCopy)
    }
    else {



      console.log(" Client Not Found Add in clients array ")
      console.log(" Now add location in clients ")
      clientCopy['locations'] = []

      clientCopy['locations'].push(locationCopy)

      this.clients.push(clientCopy)

      this.selectedClient = null
      this.selectedLocation = null


    }



    console.log(" let clientCopy ", clientCopy)
    console.log(" let locationCopy ", locationCopy)

  }


}
